import { render, staticRenderFns } from "./approvalProcessDialog.vue?vue&type=template&id=21823d7b&scoped=true"
import script from "./approvalProcessDialog.vue?vue&type=script&lang=js"
export * from "./approvalProcessDialog.vue?vue&type=script&lang=js"
import style0 from "./approvalProcessDialog.vue?vue&type=style&index=0&id=21823d7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21823d7b",
  null
  
)

export default component.exports